/**
 * JobHeader Component - Page header with back button and navigation
 */
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { JobNavigation } from './JobNavigation';

interface JobHeaderProps {
  jobId: string;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onGoBack: () => void;
}

export const JobHeader: React.FC<JobHeaderProps> = ({
  jobId,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onGoBack,
}) => {
  return (
    <div className="mb-6">
      <button
        onClick={onGoBack}
        className="flex items-center gap-2 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 mb-4"
      >
        <ArrowLeft className="w-4 h-4" />
        Voltar para Contagens
      </button>
      <div className="flex items-center gap-4">
        <JobNavigation
          hasPrevious={hasPrevious}
          hasNext={hasNext}
          onPrevious={onPrevious}
          onNext={onNext}
        />
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Detalhes da Contagem #{jobId}
        </h1>
      </div>
    </div>
  );
};
